export const generalConstants = {
    DEFAULT_ROUTE: '/home/investment/portfolio',
    DEFAULT_PAGE:[
        {
            path: "/investment/portfolio",
            name: "การลงทุนของฉัน",
            icon: "InvestmentIcon",
            layout: "/home",
            section: "sidebar"
        }
    ],

    GET_COLOR_LIST_START: 'GET_COLOR_LIST_START',
    GET_COLOR_LIST_SUCCESS: 'GET_COLOR_LIST_SUCCESS',
    GET_COLOR_LIST_FAILURE: 'GET_COLOR_LIST_FAILURE',
    
    CLEAR_COLOR_LIST: 'CLEAR_COLOR_LIST'
}